import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFooterGridComponent } from './custom-footer-grid.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [CustomFooterGridComponent],
  exports: [CustomFooterGridComponent]

})
export class CustomFooterGridModule { }



// WEBPACK FOOTER //
// ./src/app/pages/custom-footer-grid/custom-footer-grid.module.ts